<template>
  <v-container
    id="app-info-badge"
    class="pa-1"
  >
    <v-card
      ref="screen"
      class="screen mb-2 p-3 ma-0"
      light
      style="padding: 4px"
    >
      <div class="text-center font-weight-bold">
        Statut de la commande
      </div>
      <v-select
        v-if="!isDelivred"
        v-model="status"
        :items="statuses"
        item-text="text"
        item-value="value"
        :disabled="disabled"
        style="margin-top: -9px"
        @change="enableValidationButton()"
      />
      <div
        v-else
        class="pa-2"
      >
        Livrée le {{ formattedDate(badge.DateLivraison) }} à {{ formattedTime(badge.DateLivraison) }}
      </div>
    </v-card>
    <v-card
      ref="screen"
      class="screen mb-2 p-3 ma-0"
      light
      style="padding: 10px"
    >
      <div class="m-2">
        <div>Le : {{ formattedDate(badge.DateCreation) }} À {{ formattedTime(badge.DateCreation) }}</div>
        <div>CLIENT : {{ badge.Prenom }} {{ badge.Nom }}</div>
        <div>MAIL : {{ badge.Mail }}</div>
        <div>PRIX TOTAL : {{ formatPrice(badge.TotalTTC) }} € </div>
        <div>STATUT PAIEMENT : {{ getStatutPaiementStr }}</div>
      </div>
    </v-card>
    <div>
      <v-card
        v-for="(product, index) in badge.m_p_ligne_commandes"
        :key="index"
        class="screen mb-2 p-3 ma-0"
        light
        style="padding: 10px"
      >
        <div class="text-center font-weight-bold">
          {{ product.article.Libelle }}
        </div>
        <!-- ***** LIST ARTICLE ***** -->
        <div v-if="product.article.declinaison1">
          CRITÈRE 1 : {{ formatCritere(product.article.declinaison1) }}
        </div>
        <div v-if="product.article.declinaison2">
          CRITÈRE 2 : {{ formatCritere(product.article.declinaison2) }}
        </div>
        <div>QUANTITÉ : {{ product.Quantite }}</div>
        <div>PRIX UNITAIRE : {{ formatPrice(product.PrixUnitaireTTC) }} €</div>
        <div>MONTANT TOTAL : {{ formatPrice(product.MontantTTC) }} €</div>
      </v-card>
    </div>
    <bottom-action
      btn-cancel
      :btn-valid="!isButtonEnabled"
      :btn-valid-disabled="isButtonEnabled"
      @cancel="bottomCancel"
      @valid="showModal"
      @del="bottomDelete"
    />
    <ui-dialog
      v-model="dialog.show"
      :title="dialog.title"
      :content="dialog.content"
      :danger="dialog.danger"
      btn-validate="OK"
      btn-cancel="Retour"
      @validate="changeStatut"
      @hide="hideModal"
    />
  </v-container>
</template>

<script>
import { Operations } from '@/modules/Operations'
import { $alert } from '@/modules/Utils'
import {EnumCommandeStatutPreparation, EnumIDCfgMPCommandeStatut} from '@/modules/Enums';
import {Scan} from '@/modules/Scan';

export default {
  name: 'InfoCommandeView',

  components: {
  },

  props: {
    badge: { type: Object, default: null },
    carrier: { type: Object, default: null },
    customers: { type: Array, default: null },
    backToHome: { type: Boolean, default: false }
  },

  data () {
    return {
      status: this.badge.StatutPreparation ?? null,
      statuses: [
        { text: 'En attente', value: EnumCommandeStatutPreparation.EN_ATTENTE },
        { text: 'Valide', value: EnumCommandeStatutPreparation.VALIDEE },
        { text: 'En préparation', value: EnumCommandeStatutPreparation.EN_PREPARATION },
        { text: 'Préparée', value: EnumCommandeStatutPreparation.PREPAREE },
        { text: 'En livraison', value: EnumCommandeStatutPreparation.EN_LIVRAISON },
        { text: 'Délivrée', value: EnumCommandeStatutPreparation.DELIVREE },
      ],
      cancelDialog: false,
      showTransferOptions: false,
      showAmountEntry: false,
      dialog: {
        show: false,
        title: null,
        content: null,
        danger: false,
        action: () => {}
      },
      disabled : false,
      isButtonEnabled : true,
      newStatus : null
    }
  },
  computed: {
    getStatutPaiementStr () {
      if (!this.badge || !this.badge.IDCfgMPCommandeStatut) return '';
      switch (this.badge.IDCfgMPCommandeStatut) {
        case EnumIDCfgMPCommandeStatut.ERREUR:
          return 'Erreur de paiement'
        case EnumIDCfgMPCommandeStatut.PHASE_PAIEMENT:
          return 'Attente du paiement'
        case EnumIDCfgMPCommandeStatut.PAIEMENT_EFFECTUE:
          return 'Payée'
        case EnumIDCfgMPCommandeStatut.PAIEMENT_AUTORISE:
          return 'Paiement autorisée'
        default:
          return ''
      }
    },
    isDelivred() {
     return  this.badge.StatutPreparation === EnumCommandeStatutPreparation.DELIVREE
    }
  },

  beforeMount () {
    if (this.badge === null) {
      this.$router.replace('/home')
    }
  },
  methods: {
    enableValidationButton() {
      this.isButtonEnabled = this.status === this.badge.StatutPreparation || this.newStatus === this.status;
    },
    cancel () {
      Operations.badgeCancellation(
        this.badge.IDBadge,
        this.carrier,
        (message) => { $alert(message, 'success') },
        (error) => { $alert(error) }
      )
    },
    bottomDelete () {
      if (this.showTransferOptions) {
        this.showTransferOptions = false
      } else {
          this.bottomCancel()
      }
    },
    bottomCancel () {
      this.$router.replace('/home')
    },
    formatCritere(data) {
      let critere =''
      if (data) {
        if (data.TypeLibelle) {
          critere =
            data.TypeLibelle +
            ' : ' +
            data.Libelle
        } else {
          critere = data.Libelle
        }
      }
      return critere
    },
    changeStatut() {
      Scan.changeStatut(this.badge.IDMPCommande, this.status, () => {
        this.success = true
          this.dialog.show = false
          this.newStatus = this.status
        if (this.status === EnumCommandeStatutPreparation.DELIVREE) {
          this.disabled = true
        }
        this.isButtonEnabled = true
        },
        (error) => {
        $alert('Il est interdit de passer du statut '+ this.getStatutLivraison(this.badge.StatutPreparation) +' à '+ this.getStatutLivraison(this.status))
        },)
    },
    formatPrice(value) {
      return parseFloat(value).toFixed(2);
    },
    formattedDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString('fr-FR'); // Format to DD/MM/YYYY
    },
    formattedTime(value) {
      const date = new Date(value);
      return date.toLocaleTimeString('fr-FR'); // Format to HH:MM:SS
    },
    getStatutLivraison (statut) {
      switch (statut) {
        case EnumCommandeStatutPreparation.EN_ATTENTE:
          return 'En attente'
        case EnumCommandeStatutPreparation.EN_PREPARATION:
          return 'En préparation'
        case EnumCommandeStatutPreparation.VALIDEE:
          return 'Valide'
        case EnumCommandeStatutPreparation.PREPAREE:
          return 'Préparée'
        case EnumCommandeStatutPreparation.EN_LIVRAISON:
          return 'En livraison'
        case EnumCommandeStatutPreparation.DELIVREE:
          return 'Délivrée'
        default:
          return ''
      }
    },
    showModal () {
      this.dialog.title = this.$i18n.t('dialog.change_statut_title')
      this.dialog.content = this.$i18n.t('dialog.change_statut_content') + ' '+ this.getStatutLivraison(this.status)
      this.dialog.danger = true
      this.dialog.action = this.cancellation
      this.dialog.show = true
    },hideModal () {
      this.dialog.show = false
      this.isButtonEnabled = true
      this.status = this.badge.StatutPreparation
    },
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
.font-weight-bold {
  font-weight: bold;
}
.mb-2 {
  margin-bottom: 16px;
}
.mt-2 {
  margin-top: 16px;
}
.d-flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
</style>
